import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    button: {
      textTransform: 'capitalize !important',
    },
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    input: {
      display: 'none',
    },
    iframe: {
      height: 300,
      width: '100%',
      img: {
        width: '100%',
      },
    },
    title: {
      color: '#4D4F5C',
      fontSize: theme.typography.htmlFontSize,
      fontWeight: theme.typography.fontWeightBold,
      marginBottom: 0,
    },
    subtitle: {
      color: '#4D4F5C',
      fontSize: theme.typography.fontSize,
      fontWeight: theme.typography.fontWeightBold,
      marginTop: '20px',
    },
  };
});

export { useStyles };
